import React, { useState } from 'react'
import { MessageCircle } from 'lucide-react'

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  const phoneNumber = '57' // Sin el +
  const message = '¡Hola! Me gustaría obtener información sobre Las Gardenias IED.'

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`

  return (
    <>
      {/* Botón flotante principal */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 group"
        aria-label="Contactar por WhatsApp"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {/* Círculo del botón */}
        <div className="relative">
          <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:shadow-[0_0_30px_rgba(37,211,102,0.5)]">
            <MessageCircle className="h-7 w-7 sm:h-8 sm:w-8 text-white" />
          </div>
          
          {/* Pulso animado */}
          <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></div>
          
          {/* Badge de notificación */}
          <div className="absolute -top-1 -right-1 w-5 h-5 bg-gardenia-red rounded-full flex items-center justify-center">
            <span className="text-white text-xs font-bold">1</span>
          </div>
        </div>

{/* Tooltip simplificado */}
<div className={`absolute right-full mr-4 top-1/2 transform -translate-y-1/2 transition-all duration-300 ${
  isOpen ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
}`}>
  <div className="bg-white rounded-lg shadow-xl px-4 py-2 border border-gray-100 whitespace-nowrap">
    <p className="text-sm font-semibold text-gardenia-dark">
      Escríbenos
    </p>
  </div>
  <div className="absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 rotate-45 w-3 h-3 bg-white border-r border-b border-gray-100"></div>
</div>
      </a>

      {/* Versión móvil simplificada */}
      <div className="fixed bottom-20 right-6 z-40 sm:hidden">
        <div className={`bg-white rounded-lg shadow-lg p-3 transition-all duration-300 ${
          isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'
        }`}>
     
        </div>
      </div>
    </>
  )
}

export default WhatsAppButton